import React, { useState, useEffect, useContext } from 'react';
import { Box, Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Avatar, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Select, FormControl, InputLabel, CircularProgress, Alert, Tooltip } from '@mui/material';
import { PersonAdd, Edit, Block, CheckCircle } from '@mui/icons-material';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
const API = '/api';
const RC = {superadmin:'#6a0000',admin:'#E8622A',telecaller:'#2196F3',salesperson:'#4CAF50'};
const EF = {name:'',email:'',password:'',role:'telecaller',phone:''};
export default function TeamManagement() {
  const {user} = useContext(AuthContext);
  const [users,setUsers] = useState([]);
  const [loading,setLoading] = useState(true);
  const [error,setError] = useState('');
  const [open,setOpen] = useState(false);
  const [editUser,setEditUser] = useState(null);
  const [form,setForm] = useState(EF);
  const [saving,setSaving] = useState(false);
  const [fe,setFe] = useState('');
 
  const load = async () => {
    try { setLoading(true); const t=localStorage.getItem('token');
      const r = await axios.get(API+'/users',{headers:{Authorization:'Bearer '+t}});
      const fetched = r.data.users||[];
      const filtered = user?.role==='admin' ? fetched.filter(u=>u.role!=='superadmin') : fetched;
      setUsers(filtered);
    } catch(e) { setError(e.response?.data?.message||'Failed'); }
    finally { setLoading(false); }
  };
  useEffect(()=>{load();},[]);
 
  const openAdd = () => { setEditUser(null); setForm(EF); setFe(''); setOpen(true); };
  const openEdit = u => { setEditUser(u); setForm({name:u.name||'',email:u.email||'',password:'',role:u.role||'telecaller',phone:u.phone||''}); setFe(''); setOpen(true); };
 
  const save = async () => {
    if(!form.name||!form.email) return setFe('Name and email required');
    if(!editUser&&!form.password) return setFe('Password required for new user');
    try { setSaving(true); setFe('');
      const t=localStorage.getItem('token');
      const h={headers:{Authorization:'Bearer '+t}};
      if(editUser) await axios.put(API+'/users/'+editUser._id,form,h);
      else await axios.post(API+'/users',form,h);
      setOpen(false); load();
    } catch(e) { setFe(e.response?.data?.message||'Failed'); }
    finally { setSaving(false); }
  };
 
  const toggle = async (u) => {
    try { const t=localStorage.getItem('token');
      await axios.put(API+'/users/'+u._id,{isActive:!u.isActive},{headers:{Authorization:'Bearer '+t}});
      load();
    } catch(e) { alert('Failed'); }
  };
 
  if(loading) return <Box display="flex" justifyContent="center" mt={8}><CircularProgress sx={{color:'#E8622A'}}/></Box>;
 
  return (
<Box p={3}>
<Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
<Box><Typography variant="h5" fontWeight={700}>Team Management</Typography>
<Typography variant="body2" color="text.secondary">{users.length} team members</Typography>
</Box>
        {(user?.role==='admin'||user?.role==='superadmin')&&<Button variant="contained" startIcon={<PersonAdd/>} onClick={openAdd} sx={{bgcolor:'#E8622A','&:hover':{bgcolor:'#C4501F'},borderRadius:2}}>Add Member</Button>}
</Box>
      {error&&<Alert severity="error" sx={{mb:2}}>{error}</Alert>}
<TableContainer component={Paper} elevation={1} sx={{borderRadius:2}}>
<Table>
<TableHead><TableRow sx={{'& th':{bgcolor:'#F5F7FA',fontWeight:600,fontSize:12}}}>
<TableCell>#</TableCell><TableCell>Name</TableCell><TableCell>Email</TableCell>
<TableCell>Phone</TableCell><TableCell>Role</TableCell><TableCell>Status</TableCell>
<TableCell>Joined</TableCell>{(user?.role==='admin'||user?.role==='superadmin')&&<TableCell>Actions</TableCell>}
</TableRow></TableHead>
<TableBody>
            {users.map((u,i)=>(
<TableRow key={u._id} hover sx={{'&:hover':{bgcolor:'#FFF8F5'}}}>
<TableCell sx={{color:'#999',fontSize:11}}>{i+1}</TableCell>
<TableCell><Box display="flex" alignItems="center" gap={1}>
<Avatar sx={{bgcolor:RC[u.role]||'#E8622A',width:32,height:32,fontSize:13,fontWeight:700}}>{u.name?.charAt(0)}</Avatar>
<Typography variant="body2" fontWeight={500}>{u.name}</Typography>
</Box></TableCell>
<TableCell sx={{fontSize:12,color:'#2196F3'}}>{u.email}</TableCell>
<TableCell sx={{fontSize:12}}>{u.phone||'-'}</TableCell>
<TableCell><Chip label={u.role} size="small" sx={{bgcolor:(RC[u.role]||'#E8622A')+'20',color:RC[u.role]||'#E8622A',fontWeight:600,fontSize:11}}/></TableCell>
<TableCell><Chip label={u.isActive?'Active':'Inactive'} size="small" sx={{bgcolor:u.isActive?'#4CAF5020':'#F4433620',color:u.isActive?'#4CAF50':'#F44336',fontSize:11}}/></TableCell>
<TableCell sx={{fontSize:11,color:'#999'}}>{new Date(u.createdAt).toLocaleDateString()}</TableCell>
                {(user?.role==='admin'||user?.role==='superadmin')&&<TableCell><Box display="flex" gap={0.5}>
<Tooltip title="Edit"><IconButton size="small" onClick={()=>openEdit(u)} sx={{color:'#2196F3'}}><Edit sx={{fontSize:16}}/></IconButton></Tooltip>
<Tooltip title={u.isActive?'Deactivate':'Activate'}><IconButton size="small" onClick={()=>toggle(u)} sx={{color:u.isActive?'#F44336':'#4CAF50'}}>{u.isActive?<Block sx={{fontSize:16}}/>:<CheckCircle sx={{fontSize:16}}/>}</IconButton></Tooltip>
</Box></TableCell>}
</TableRow>
            ))}
</TableBody>
</Table>
</TableContainer>
<Dialog open={open} onClose={()=>setOpen(false)} maxWidth="sm" fullWidth PaperProps={{sx:{borderRadius:3}}}>
<DialogTitle fontWeight={700}>{editUser?'Edit Team Member':'Add Team Member'}</DialogTitle>
<DialogContent>
          {fe&&<Alert severity="error" sx={{mb:2,mt:1}}>{fe}</Alert>}
<Box display="flex" flexDirection="column" gap={2} mt={1}>
<Box display="flex" gap={2}>
<TextField fullWidth label="Full Name *" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} size="small"/>
<TextField fullWidth label="Phone" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} size="small"/>
</Box>
<TextField fullWidth label="Email *" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} size="small" disabled={!!editUser}/>
<TextField fullWidth label={editUser?"New Password (leave blank to keep)":"Password *"} type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} size="small"/>
<FormControl fullWidth size="small"><InputLabel>Role</InputLabel>
<Select value={form.role} label="Role" onChange={e=>setForm({...form,role:e.target.value})}>
<MenuItem value="admin">Admin</MenuItem>
<MenuItem value="telecaller">Telecaller</MenuItem>
<MenuItem value="salesperson">Salesperson</MenuItem>
                <MenuItem value="lead_management">Lead Management</MenuItem>
</Select>
</FormControl>
</Box>
</DialogContent>
<DialogActions sx={{p:2}}>
<Button onClick={()=>setOpen(false)}>Cancel</Button>
<Button variant="contained" onClick={save} disabled={saving} sx={{bgcolor:'#E8622A','&:hover':{bgcolor:'#C4501F'},borderRadius:2}}>
            {saving?<CircularProgress size={18} sx={{color:'white'}}/>:(editUser?'Update':'Add')}
</Button>
</DialogActions>
</Dialog>
</Box>
  );
}